import * as React from "react";
const SvgEdit = () => /* @__PURE__ */ React.createElement("svg", { width: 24, height: 24, fill: "none" }, /* @__PURE__ */ React.createElement(
  "path",
  {
    fill: "currentColor",
    fillRule: "evenodd",
    d: "M16.944 3.116 15.39 4.672l3.939 3.94 1.556-1.556a1.25 1.25 0 0 0 0-1.768l-2.172-2.172a1.25 1.25 0 0 0-1.768 0m5 5a2.75 2.75 0 0 0 0-3.888l-2.172-2.172a2.75 2.75 0 0 0-3.888 0L2.47 15.47a.75.75 0 0 0-.21.407l-1 6a.75.75 0 0 0 .863.863l6-1a.75.75 0 0 0 .407-.21zm-3.677 1.556-3.939-3.94L3.7 16.36l-.788 4.728L7.64 20.3z",
    clipRule: "evenodd"
  }
));
export default SvgEdit;
